import React, { useEffect, useState } from 'react';
import { Modal, Input, Button, Form } from 'antd';
import './restoreMachineModal.scss';

interface Props {
    isShow: boolean;
    machineId?: number;
    onClose: () => void;
    onSubmit: (inValue: number, outValue: number) => void;
}

const RestoreMachineModal: React.FC<Props> = ({ isShow, machineId, onClose, onSubmit }) => {
    const [open, setOpen] = useState(isShow);
    const [inValue, setInValue] = useState<string>('');
    const [outValue, setOutValue] = useState<string>('');

    useEffect(() => {
        setOpen(isShow);
        if (isShow) {
            setInValue('');
            setOutValue('');
        }
    }, [isShow]);

    const handleSave = () => {
        const inNum = inValue === '' ? 0 : Number(inValue);
        const outNum = outValue === '' ? 0 : Number(outValue);
        onSubmit(inNum, outNum);
    };

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            centered
            width={400}
            title={
                <div
                    style={{
                        textAlign: 'center',
                        fontWeight: 400,
                        fontSize: 22,
                        color: '#ccc',
                        padding: '2px 0 2px 0',
                    }}
                >
                    Reset Machine
                </div>
            }
            className="rs-modal restore-machine-dark-modal"
            bodyStyle={{ background: '#000', borderRadius: 12, padding: 16 }}
        >
            <Form layout="vertical">
                <Form.Item label={<span style={{ color: '#ccc', fontWeight: 500, fontSize: 15 }}>Initial IN</span>}>
                    <Input
                        placeholder="0"
                        value={inValue}
                        onChange={e => setInValue(e.target.value.replace(/[^0-9]/g, ''))}
                        maxLength={12}
                        className="restore-machine-dark-input"
                        style={{ background: '#181818', color: '#fff', border: '1px solid #222', borderRadius: 8, fontSize: 16, padding: '7px 12px' }}
                    />
                </Form.Item>
                <Form.Item label={<span style={{ color: '#ccc', fontWeight: 500, fontSize: 15 }}>Initial OUT</span>}>
                    <Input
                        placeholder="0"
                        value={outValue}
                        onChange={e => setOutValue(e.target.value.replace(/[^0-9]/g, ''))}
                        maxLength={12}
                        className="restore-machine-dark-input"
                        style={{ background: '#181818', color: '#fff', border: '1px solid #222', borderRadius: 8, fontSize: 16, padding: '7px 12px' }}
                    />
                </Form.Item>
                <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginTop: 12 }}>
                    <Button className="rs-button default-outlined" onClick={onClose} style={{ background: '#232323', color: '#fff', border: '1px solid #444', borderRadius: 8, fontSize: 15, padding: '6px 18px' }}>Cancel</Button>
                    <Button type="primary" className="rs-button restore-machine-save-btn" onClick={handleSave} style={{ fontSize: 15, padding: '6px 18px' }}>Save</Button>
                </div>
            </Form>
        </Modal>
    );
};

export default RestoreMachineModal; 